
jQuery(document).ready(function($){
  if(window.innerWidth < 990){
    $('.big-megamenu ul.nav li.pt-mm-tab').first().addClass('show');
    $('.pt-mm-panels > *').first().addClass('show');
    
    $('li.pt-mm-tab').removeClass('show');
    $('.big-megamenu ul.nav li.pt-mm-tab').on('click', function(e){
      e.preventDefault();

      var index = $(this).index();

      // Remove .show from all top li and add to clicked
      // $('.big-megamenu ul.nav li.pt-mm-tab').removeClass('show');
      this.classList.toggle('show');

      $('.pt-mm-panels > *').removeClass('show');
      $('.pt-mm-panels > *').eq(index).addClass('show');
    });
  }
});

document.querySelectorAll('details').forEach(detail => {
  const svg = detail.querySelector('#menu-drawer summary svg');
  if (!svg) return;
  
  svg.style.transition = 'transform 0.3s ease';
  svg.style.transformOrigin = 'center';

  let initialized = false;
  detail.addEventListener('toggle', () => {
    if (initialized) {
      svg.style.transform = detail.open ? 'rotate(180deg)' : 'rotate(0deg)';
    }
    initialized = true;
  });
});





